import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem } from 'react-bootstrap';

import './Pagnition.css';

const NUMBER_ROWS = [10, 15, 20, 30];

export default class Pagnition extends Component {
  static propTypes = {
    items: PropTypes.array,
    onChangePage: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
    initialPage: PropTypes.number,
  }

  static defaultProps = {
    items: [],
    initialPage: 1,
    onSelect: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      pager:{},
      numberRows: NUMBER_ROWS,
      currentSelect: NUMBER_ROWS[2],
    };
  }

  componentDidMount() {
    if(this.props.items && this.props.items.length) {
      this.setPage(this.props.initalPage);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setPage(this.props.initialPage);
    }
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, () => {
        resolve();
      });
    });
  }

  handleSelect = async (currentSelect) => {
    var pager = this.state.pager;

    this.setState({
      currentSelect,
    }, () => {
      this.setPage(pager.currentPage);
    });
  }

  setPage(page) {
    var items = this.props.items;
    var pager = this.state.pager;

    pager = this.getPager(items.length, page);
    const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1 );
    this.setState({ pager, reveal: null }, () => {
      this.props.onChangePage(pageOfItems, this.state.reveal);
    });

    if(page < 1 || page > pager.totalPages) {
      return;
    }
  }

  getPager(totalItems, currentPage, pageSize) {
    currentPage = currentPage || 1;
    pageSize = this.state.currentSelect;

    const totalPages = Math.ceil(totalItems / pageSize);
    let startPage, endPage;
    if (totalPages <= 10) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
    const pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

    return {
      totalItems,
      currentPage,
      pageSize,
      totalPages,
      startPage,
      endPage,
      startIndex,
      endIndex,
      pages,
    };
  }

  render() {
    const { pager } = this.state;
    if (!pager.pages || pager.pages.length <= 1) {
      return null;
    }

    return (
      <div className="Pagnition">
        <ul className="pagination">
          <li className={pager.currentPage === 1 ? 'disabled' : ''}>
            <a onClick={() => this.setPage(1)}>First</a>
          </li>
          <li className={pager.currentPage === 1 ? 'disabled' : ''}>
            <a onClick={() => this.setPage(pager.currentPage - 1)}>Previous</a>
          </li>
          {pager.pages.map((page, index) =>
            <li key={index} className={pager.currentPage === page ? 'active' : ''}>
              <a onClick={() => this.setPage(page)}>{page}</a>
            </li>
          )}
          <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
            <a onClick={() => this.setPage(pager.currentPage + 1)}>Next</a>
          </li>
          <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
            <a onClick={() => this.setPage(pager.totalPages)}>Last</a>
          </li>
        </ul>

        <DropdownButton title={`${this.state.currentSelect} rows`} id="filterRow" dropup>
         {
           this.state.numberRows.map(i => (
             <MenuItem
               key={i}
               eventKey={i}
               onSelect={this.handleSelect}
             >
               {i}
             </MenuItem>
           ))
         }
      </DropdownButton>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pagnition.jsx